import { openDB, IDBPDatabase } from 'idb';

const DB_NAME = 'chartflow-offline';
const DB_VERSION = 1;

let dbPromise: Promise<IDBPDatabase> | null = null;

function getDB() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('charts')) {
          db.createObjectStore('charts', { keyPath: 'key' });
        }
        if (!db.objectStoreNames.contains('syncQueue')) {
          db.createObjectStore('syncQueue', { keyPath: 'id', autoIncrement: true });
        }
        if (!db.objectStoreNames.contains('images')) {
          db.createObjectStore('images', { keyPath: 'url' });
        }
        if (!db.objectStoreNames.contains('cache')) {
          db.createObjectStore('cache', { keyPath: 'key' });
        }
      },
    });
  }
  return dbPromise;
}

export async function saveChartLocally(key: string, data: any) {
  const db = await getDB();
  await db.put('charts', { key, data, savedAt: Date.now() });
}

export async function getLocalChart(key: string) {
  const db = await getDB();
  const result = await db.get('charts', key);
  return result?.data || null;
}

export async function addToSyncQueue(action: {
  type: string;
  url: string;
  method: string;
  body: any;
}) {
  const db = await getDB();
  await db.add('syncQueue', { ...action, createdAt: Date.now() });
}

export async function getSyncQueue() {
  const db = await getDB();
  return db.getAll('syncQueue');
}

export async function clearSyncQueueItem(id: number) {
  const db = await getDB();
  await db.delete('syncQueue', id);
}

export async function processSyncQueue() {
  const queue = await getSyncQueue();
  for (const item of queue) {
    try {
      const res = await fetch(item.url, {
        method: item.method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(item.body),
      });
      if (res.ok) {
        await clearSyncQueueItem(item.id);
      }
    } catch {
      break;
    }
  }
}

export async function cacheData(key: string, data: any) {
  const db = await getDB();
  await db.put('cache', { key, data, cachedAt: Date.now() });
}

export async function getCachedData(key: string) {
  const db = await getDB();
  const result = await db.get('cache', key);
  return result?.data || null;
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    processSyncQueue();
  });

  if (navigator.onLine) {
    setTimeout(() => processSyncQueue(), 3000);
  }
}
